import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, ViewEncapsulation, AfterContentChecked } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { JubloMessageApi, JubloMessageTypes, JubloMessengerHelper } from './messageHelper';
import { CasePartnerFunctions } from '../details/case-partners/casePartnerFunctions';
import { NotificationFunctions, NotificationSets } from '../../settings/notifications/notifications';
import { ClickPreventer } from '../../shared/utilities/developHelpers';
import { MessengerPDF } from './messageToPDF';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { Htmls, Texts } from '../../shared/utilities/shared.functions';
import { IdName, SubscriptionObject } from 'app/shared/models/standard.models';
import { CompanyService } from 'app/shared/services/company.service';

@Component({
  selector: 'app-jublo-messenger',
  templateUrl: './jublo-messenger.component.html',
  styleUrls: ['./jublo-messenger.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class JubloMessengerComponent implements OnInit, OnChanges, OnDestroy, AfterContentChecked {
  @Input() caseId;
  @Input() case;
  @Input() notificationReciever;
  @Output() notificationRecieverChange = new EventEmitter();
  subscriptions: SubscriptionObject = {};
  api = new JubloMessageApi(this.http);
  message = new JubloMessengerHelper(this.sanitizer, this.sharedData, this.companyService);
  partner = new CasePartnerFunctions(this.http);
  type = new JubloMessageTypes();
  notifications = new NotificationFunctions(this.http);
  //partners
  fromPartner;
  toPartners = [];
  hasPartners = false;
  partnerById: any = {}
  // sending status
  messageTo = 'customer';
  validation;
  resendModal = false;
  fileHover = false;
  // messages
  allMessages: JubloMessage[] = [];
  filteredMessages;
  filterInternals = false;
  pendingMessages: JubloPendingMessage[] = [];
  filteredPendingMessages: JubloPendingMessage[] = [];
  resendMessageText;
  nico = new ClickPreventer();
  pdf = new MessengerPDF();
  document;
  companyUsers;
  user;
  userTagId: string = null;
  userTagName: '' = null;
  userTagSearch: string = null;
  userTagList = [];
  taggableUsers = [];

  constructor(private http: HttpClient, private translate: TranslateService, private sharedData: SharedDataService, private sanitizer: DomSanitizer, private companyService: CompanyService) { }

  ngOnInit(): void {
    document.addEventListener('click', (e) => this.clickListener(e));
    this.subscriptions['companyUsers'] = this.sharedData.companyUsers().subscribe(data => {
      this.companyUsers = data;
      let a = localStorage.getItem('bearer');
      this.user = this.companyUsers.find(x => x.userId == a).name;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.caseId && !!changes.caseId.currentValue && !!changes.caseId.firstChange) {
      this.getPartnerData();
      this.getPending();
      this.notifications.getNotificationSets().subscribe(
        (data: any) => {
          if (!!data && data.length > 1) {
            this.notifications.sets = data.sort((a, b) => a.priority < b.priority ? -1 : 1);
            if (!!this.notifications.sets && !this.case.notificationSetId) {
              this.case.notificationSetId = this.notifications.sets[0].id;
            }
          }
        }
      );
    }
    if (!!this.case && !!this.notificationReciever) {
      this.validation = this.message.validateCaseMessaging(this.case, this.notificationReciever);
    }
  }

  ngAfterContentChecked() {
    this.textAreaDisabled();
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', (e) => this.clickListener(e));
    for(let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
    this.subscriptions.companyUsers.unsubscribe();
  }

  getMessages() {
    this.api.caseMessages(this.caseId).subscribe(
      (data: any[]) => {
        let m = this.message.cleanMessages(data.map(x => {
          return {
            ...x,
            showFiles: false,
            files: [],
            type: this.type.getMessageType(x.messageTypeId),
            sender: this.getSender(x),
            showMenu: false
          }
        }));
        this.allMessages = this.allMessages.concat(m).sort((a, b) => a.sentAt < b.sentAt ? 1 : -1);
        //console.log(this.allMessages);
        //.filter(x => x.type != 'systemInternal');
        for (let x of Object.keys(this.partnerById)) {
          if (!!this.partnerById[x].messagesLoaded) this.partnerById[x].messagesLoaded = false;
        }
        this.filterMessages();
      }
    )
    this.api.caseMessageRead(this.caseId).subscribe(() => { })
  }

  getPending() {
    this.api.getPendingNotifications(this.caseId).subscribe(
      (data: PendingMessage[]) => {
        this.pendingMessages = !!data ? data.map(x => { return { ...x, open: false, date: x.sendingAt.split('T')[0], time: x.sendingAt.split('T')[1].slice(0, 5) } }).sort((a, b) => a.sendingAt > b.sendingAt ? -1 : 1) : [];
        this.filterMessages();
      }
    )
  }

  getSender(x) {
    if (!!x.sentBy && !!x.sentBy.stakeholderId && ['company', 'internal', 'partner'].includes(this.type.getMessageType(x.messageTypeId))) { return x.sentBy.name }
    if (!!x.sentByCustomer && !!x.sentByCustomer.stakeholderId && this.type.getMessageType(x.messageTypeId) == 'customer') { return x.sentByCustomer.name }
    return null
  }

  getPartnerData() {
    this.partner.getCaseFromPartner(this.caseId).subscribe(
      (data: any) => {
        this.fromPartner = data;
        if (!!data) {
          this.hasPartners = true;
          this.messageTo = data.caseId;
          this.partnerById[data.caseId] = { caseData: data }
          this.api.getFromPartnerMessageBadge(data.caseId).subscribe(
            (badgeData) => {
              this.partnerById[data.caseId]['badge'] = badgeData;
            }
          )
          this.getPartnerMessages(data.caseId, false);
        }
        this.getMessages();
      }
    )
    this.partner.getCaseDistributedPartners(this.caseId).subscribe(
      (data: any[]) => {
        this.toPartners = data;
        if (!!data && data.length > 0) {
          this.hasPartners = true;
          for (let x of data) {
            this.partnerById[x.caseId] = { caseData: x }
            this.api.getToPartnersMessageBadges(x.caseId).subscribe(
              (badgeData) => {
                this.partnerById[x.caseId]['badge'] = badgeData;
              }
            )
          }
        }
      }
    )
  }

  async filterMessages() {
    let stringSearchIds = await this.message.filterVisibleByString(this.message.filterString);
    // console.log(this.allMessages.filter(x => !x.type))
    switch (this.messageTo) {
      case ('internal'): {
        this.filteredMessages = this.allMessages.filter(x => x.type == 'internal');
        //console.log(this.filteredMessages);
        this.filteredPendingMessages = this.pendingMessages;
        break;
      }
      case ('customer'): {
        this.filteredMessages = this.allMessages.filter(x => !['toPartner', 'fromPartner'].includes(x.type) && x.messageTypeId != 'dbe287c5-6011-47f3-88e8-eafa671d1ed6');
        //console.log(this.filteredMessages);
        this.filteredPendingMessages = this.pendingMessages;
        break;
      }
      default: {
        this.filteredMessages = this.allMessages.filter(x => x.caseId == this.messageTo);
        //console.log(this.filteredMessages)
        this.filteredPendingMessages = [];
        break;
      }
    }
    if (stringSearchIds.length > 0) {
      this.filteredMessages = this.filteredMessages.filter(x => stringSearchIds.includes(x.messageId));
      this.filteredPendingMessages = this.pendingMessages.filter(x => stringSearchIds.includes(x.id));
    }
    //console.log(this.filteredMessages)
    // if (this.messageTo != 'internal') {
    //   this.filteredMessages = this.filteredMessages.filter(x => x.type != 'systemInternal' && ((x.smsSent || x.emailSent) && x.type != 'internal')); 
    // }
  }

  clearFilters() {
    this.message.filterString = '';
    this.filterInternals = false;
    this.filterMessages();
    this.textAreaDisabled();
  }

  sendMessage() {
    if (this.nico.clickAllowed()) {
      switch (this.messageTo) {
        case ('customer'): {
          let text = this.message.content.text;
          if (!!this.resendMessageText) {
            text = this.resendMessageText;
          }
          this.api.sendMessage(this.caseId, text, this.message.content.files.map(x => x.fileId)).subscribe(
            () => { this.messagePosted(); }
          );
          break;
        }
        case ('internal'): {
          this.api.sendCompanyOnlyMessage(this.caseId, this.message.content.text, this.message.content.files.map(x => x.fileId)).subscribe(
            () => { this.messagePosted(); }
          );
          break;
        }
        default: {
          this.api.sendMessageToPartner(this.messageTo, this.message.content.text, this.message.content.files).subscribe(
            () => {
              this.allMessages = this.allMessages.filter(x => x.caseId != this.messageTo);
              this.message.resetMessage();
              this.getPartnerMessages(this.messageTo, true);
            },
            (err) => console.log('Message did not send', err)
          );
          break;
        }
      }
    }

    if (!!this.userTagList && this.userTagList.length > 0) {

      let stakeholders = new Array;
      let message = this.message.content.text
      for (let x of this.userTagList) {
        stakeholders.push(x.id.toString());
        let s = '@' + x.name;
        message = message.replace(s, '<span style="font-weight: bold; color: #007bff">@' + x.name + '</span>');
      }

      let data = {
        StakeholderIds: stakeholders,
        title: 'Messages.CaseMessage',
        message: message,
        messageTypeId: '69dd7e3d-4f8a-4c84-b23a-186462023e75',
        caseId: this.caseId,
        offerId: null,
        originId: null,
        icon: null
      }

      //console.log(data);

      this.api.sendAlertMessageToStakeholders(data).subscribe(
        (data) => {
          //console.log(data);
        },
        (err) => console.log(err)
      )
    }
    document.getElementById('newMessageText').innerHTML = '';
    this.message.content.text = '';
    this.userTagList = [];
  }

  messagePosted() {
    this.allMessages = [];
    this.message.resetMessage();
    let textarea = document.getElementById('newMessageText') as HTMLTextAreaElement;
    textarea.style.height = '34px';
    setTimeout(() => this.getMessages(), 500);
  }

  switchNotificationReciever(type, resend) {
    this.api.patchCaseNotificationReciever(this.caseId, type).subscribe(
      () => {
        this.notificationRecieverChange.emit(type);
        if (resend) {
          this.sendMessage();
        }
      }
    )
  }

  displayFiles(x: JubloMessage) {
    if (x.fileId.length != x.files.length) {
      this.api.caseMessageFiles(this.caseId).subscribe(
        (data: File[]) => {
          if (!!data) {
            data.forEach(file => {
              this.allMessages.filter(x => !!x.fileId && x.fileId.includes(file.fileId) && !x.files.find(y => y.fileId == file.fileId)).forEach(m => m.files.push(file))
            })
            this.filterMessages();
          }
        }
      )
    }
    x.showFiles = !x.showFiles
  }

  getFileHeight(x) {
    return ((Math.ceil(x.fileId.length / 4)) * 8.8) + 'rem';
  }

  getCaretPosition(event){
    let c = Texts.getCaretPosition();
    c.focusNode.textContent;
  }

  messageInput(event) {
    this.autoSizeTextInput(event);
    this.message.content.text = event.target.innerText as string;
    if(!this.message.content.text || this.message.content.text == '\n') {
      this.taggableUsers = [];
      this.userTagList = [];
    }
    // if user used enter key while tagging
    if (event.key == 'Enter' && event.target.innerText.includes('@') && this.taggableUsers.length > 0) {
      event.preventDefault();
      this.tagUser(this.taggableUsers[0]);
    } 
    // if user is in process of tagging
    else if (event.target.innerText.includes('@')) {
      // console.log('Finding user')
      this.findUser(this.message.content.text,event.target.innerText);
    }
    else {
      this.userTagId = null;
      this.userTagName = null;
      this.taggableUsers = [];
    }
  }

  findUser(text, line) {
    this.userTagId = null;
    this.userTagName = null;
    // let l = line.split('@').pop().split(' ')[0];
    let all = line.split('@').slice(1).map(x => x.split(' ')[0]).filter(x => !!x);
    let s = Texts.getCaretPosition().focusNode as any;
    let l = s.data.trim().replace('@','');
    let users = new Set();
    all.forEach(x => this.companyUsers.filter(user => !users.has(user.userId) && user.name.toLowerCase().match(x.toLowerCase())).map(x => x.userId).forEach(x => users.add(x))  )
    this.taggableUsers = this.companyUsers.filter(x => !!users.has(x.userId) && (this.userTagList.map(x => x.id)).indexOf(x.userId) == -1 ).map(x=>{return {id:x.userId, name:x.name}});
    this.userTagSearch = l;
    if (!!l && l.length > 1) {
      let tagged = [];
      let tag = this.userTagList.map(x => { x.id });

      for (let x of this.userTagList) { tagged.push(x.id)  }
      let userList = this.companyUsers.filter(x => !tagged.includes(x.userId));
      if (userList.filter(x => x.name.toLowerCase().match(this.userTagSearch.toLowerCase())).length > 0) {
        this.userTagId = this.companyUsers.filter(x => x.name.toLowerCase().match(this.userTagSearch.toLowerCase()))[0].userId;
        this.userTagName = this.companyUsers.filter(x => x.name.toLowerCase().match(this.userTagSearch.toLowerCase()))[0].name;
      }
    }
  }

  autoSizeTextInput(event){
    event.target.style.height = '4rem';
    if (event.target.scrollHeight + 20 < 300) {
      event.target.style.height = event.target.scrollHeight + 20 + "px";
    } else {
      event.target.style.height = "300px";
    }
  }

  listen(event){
    event.target.addEventListener('keyup',(e)=> this.messageInput(e))
  }

  dontListen(event){
    event.target.removeEventListener('keyup',(e)=> this.messageInput(e))
  }

  tagUser(user:IdName) {
    console.log(this.userTagSearch)
    let a = document.getElementById('newMessageText');
    a.innerHTML = a.innerHTML.replace('@' + this.userTagSearch, '<span style="font-weight: bold; color: #007bff" contenteditable="false">@' + user.name + '</span>&nbsp;');
    this.userTagList.push(user);
    this.taggableUsers = [];
    this.userTagId = null;
    this.userTagName = null;
    this.setCaretToEnd(a);
    this.htmlToText();
  }

  htmlToText(){
    let doc = document.getElementById('newMessageText');
    this.message.content.text = doc.innerText;
    console.log(this.message.content.text)
  }

  setCaretToEnd(target:HTMLElement) {
    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(target);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    target.focus();
    range.detach(); // optimization

    // set scroll to the end if multiline
    target.scrollTop = target.scrollHeight;
  }

  removeTag(user) {
    this.message.content.text = this.message.content.text.replace('<span style="font-weight: bold; color: #007bff" contenteditable="false">@' + user.name + '</span>', '');
    let doc = document.getElementById('newMessageText');
    doc.innerHTML = this.message.content.text;
    this.userTagList = this.userTagList.filter(x => x.id != user.id);
  }

  imgDrop(files) {
    if (!!files && !files[0].name.includes('.msg')) {
      for (let file of files) {
        //console.log(file);
        this.api.fileUpload(file).subscribe(
          (data) => {
            this.message.content.files.push(data)
            //console.log(this.message.content.files);
          },
          (err) => { console.log('could not upload file', err) }
        )
      }
    }
    else {

    }
  }

  getStatusBadge(id) {
    switch (id) {
      case ('8850aee1-48a3-48a6-aa98-2e1597b7b1d7'): { return 'badge-success' }
      case ('6991f0ea-bdb5-4e30-868f-46c43d712e9b'): { return 'badge-primary' }
      case ('99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0'): { return 'badge-warning' }
      case ('7bccdf15-ad49-4cc9-b358-68e08287f32f'): { return 'badge-secondary' }
      case ('b56c96f0-0e8c-4a9f-8faf-70eea6f6b0b7'): { return 'badge-light' }
      case ('bb7dcbad-b634-4d41-9b1b-480f25dd782b'): { return 'badge-light' }
      case ('71c47a4a-f277-42c5-8d88-b17db5a4f78f'): { return 'badge-success' }
      case ('a693c47f-9685-4bb6-bf6e-bcab86cb88de'): { return 'badge-danger' }
    }
  }

  getPartnerMessages(caseId: string, reload: boolean) {
    if (!this.partnerById[caseId]['messagesLoaded'] || reload) {
      this.allMessages = this.allMessages.filter(x => x.caseId != caseId)
      this.api.getPartnerMessages(caseId).subscribe(
        (data: PartnerMessage[]) => {
          if (!!data) {
            let m = data.map(x => this.partnerMessageToJubloMessage(x, caseId));
            this.allMessages = this.allMessages.concat(m);
            this.partnerById[caseId]['messagesLoaded'] = true;
            this.filterMessages();
          }
        }
      )
      this.api.caseMessageRead(caseId).subscribe(() => { 
      })
    }
    else {
      this.clearFilters();
    }
  }

  partnerMessageToJubloMessage(m: PartnerMessage, caseId: string): JubloMessage {
    return {
      caseId: caseId,
      description: m.message,
      diag: null,
      emailSent: false,
      fileId: m.files.map(x => x.fileId),
      files: m.files,
      messageId: m.id,
      messageReadAt: m.messageRead,
      messageReadByCustomer: false,
      messageTypeId: null,
      receiverMail: null,
      receiverMobile: null,
      sender: m.sentBy,
      sentAt: m.createdAt,
      sentBy: m.companyName != this.partnerById[caseId].caseData.companyName ? { stakeholderId: null, name: m.sentBy } : null,
      sentByCustomer: m.companyName == this.partnerById[caseId].caseData.companyName ? { stakeholderId: null, name: m.sentBy } : null,
      shortDescription: null,
      showFiles: false,
      smsSent: false,
      state: null,
      showMenu: false,
      type: m.companyName != this.partnerById[caseId].caseData.companyName ? 'toPartner' : 'fromPartner'
    }
  }

  getStandardTexts() {
    if (!this.message.standardTexts) {
      this.api.getStandardTexts().subscribe(
        (data: any) => {
          if (!!data) {
            let parsedData = JSON.parse(data);
            this.message.standardTexts = parsedData.texts.filter(x => x.inMessage == true).sort((a, b) => a.header.toLowerCase() < b.header.toLowerCase() ? -1 : 1);
            this.message.showStandardTexts = true;
          }

        }
      )
    }
    else { setTimeout(() => this.message.showStandardTexts = true, 150) }
  }

  addStandardText(t) {
    this.message.content.text = this.message.content.text + t.content;
    let doc = document.getElementById('newMessageText');
    doc.innerHTML = this.message.content.text;
    setTimeout(() => {
      let event = new Event('keyup');
      let a = document.getElementById('newMessageText') as HTMLTextAreaElement;
      a.dispatchEvent(event);
    }, 150)
  }

  clickListener(event) {
    if (!!this.message.showStandardTexts) {
      setTimeout(() => this.message.showStandardTexts = false, 300)
    }
    if (!!this.notifications.showSets) {
      setTimeout(() => this.notifications.showSets = false, 300)
    }
  }

  pendingToggle(x) {
    this.api.pendingMessageToggle(x.id).subscribe(
      () => this.getPending()
    )
  }

  editPendingMessage(x) {
    let newDate = new Date(x.date + 'T' + x.time + 'Z').toISOString()
    this.api.changePendingMessage(x.id, new Date(x.date + 'T' + x.time + 'Z')).subscribe(
      () => this.getPending()
    )
  }

  toggleNotifications() {
    this.api.caseNotificationToggle(this.caseId, !!this.case.disableNotifications).subscribe(
      {
        next:() => {
          this.case.disableNotifications = !!this.case.disableNotifications ? null : 'fake';
          this.textAreaDisabled();
        }
      }
    )
  }

  textAreaDisabled() {
    let t = document.getElementById('newMessageText') as HTMLElement;
    t.contentEditable = (!!this.case.disableNotifications && this.messageTo == 'customer' ? 'false' : 'true');
  }

  sendMessageToPartner() {
    let ta = document.getElementById('forwardMessageToPartnerText') as HTMLTextAreaElement;
    this.api.sendMessageToPartner(this.messageTo, ta.value, []).subscribe(
      () => this.getPartnerMessages(this.messageTo, true)
    );
  }

  markAsUnread(id) {
    this.api.markAsUnread(id).subscribe(
      (data) => {
        switch (this.messageTo) {
          case ('customer'):
          case ('internal'): { ; break }
          default: {
            this.partnerById[this.messageTo].badge = this.partnerById[this.messageTo].badge + 1;
            break
          }
        }
      },
      (err) => { console.log('could not mark message as unread', err) }
    )
  }

  delayOpen(id) {
    switch (id) {
      case ('notificationSets'): setTimeout(() => this.notifications.showSets = true, 100)
    }
  }

  updateNotificationSetId(id) {
    if (this.case.notificationSetId != id) {
      this.notifications.updateCaseNotificationSet(this.caseId, id).subscribe(
        () => { this.case.notificationSetId = id }
      )
    }
  }

  async makePrintable() {
    this.document = await this.pdf.collectPdfData();
    this.document.open()
  }

  async resendMessage(x) {
    if (this.messageTo == 'customer') this.message.resendMessage(x);
    else this.message.resendMessage(x);
    let text = document.getElementById('resendMessageText') as HTMLTextAreaElement;
    this.resendMessageText = text.value;
  }

  test(e) {
    console.log(e)
  }
}

interface JubloMessage {
  caseId: string;
  description: string;
  diag;
  emailSent: boolean;
  fileId: string[];
  files: File[];
  messageId: string;
  messageReadAt: string;
  messageReadByCustomer: boolean;
  messageTypeId: string;
  receiverMail: string;
  receiverMobile: string;
  sender: string;
  sentAt: string;
  sentBy: StakeHolderName;
  sentByCustomer: StakeHolderName;
  shortDescription: string;
  showFiles: boolean;
  smsSent: boolean;
  state;
  type: string;
  showMenu: boolean;
}

interface StakeHolderName {
  stakeholderId: string;
  name: string;
}

interface File {
  extension: string;
  fileAccess: string;
  fileId: string;
  fileTypeId: string;
  originalName: string;
  path: string;
}

interface PartnerMessage {
  companyId: string;
  companyName: string;
  createdAt: string;
  files: File[]
  id: string
  message: string;
  messageRead: string;
  sentBy: string;
}

class PendingMessage {
  email: string;
  id: string;
  notificationTypeId: string;
  sending: boolean;
  sendingAt: string;
  shortDescription: string;
  sms: string;
}

class JubloPendingMessage extends PendingMessage {
  open: boolean;
  date: string;
  time: string;
}
